import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { AdminService } from '../admin.service';
import { Application, Unit } from '../../models/admin-models';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-unit-profile-upload',
  templateUrl: './unit-profile-upload.component.html',
  styleUrls: ['./unit-profile-upload.component.scss'],
  imports: [
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    MatDialogModule,
    AsyncPipe,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class UnitProfileUploadComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  dialogRef = inject<MatDialogRef<UnitProfileUploadComponent>>(MatDialogRef);

  file;
  fileName;
  uploadForm: FormGroup;
  status;
  statusClass;
  filteredUnits;
  unitsControl = new FormControl();
  units: Unit[] = [] as Unit[];
  applications: Application[] = [
    { value: 'aw', name: 'Annuity Wizard' },
    { value: 'cp', name: 'Client Profiler' },
    { value: 'iw', name: 'Investment Wizard' },
    { value: 'li', name: 'Life Insurance Wizard' },
    { value: 'pp', name: 'Product Profiler' },
    { value: 'rb', name: 'Control KB (RB)' },
    { value: 'cm', name: 'Case Management (CM)' },
    { value: 'pm', name: 'Book Management (PM)' },
    { value: 'dl', name: 'Transaction Monitor' },
    { value: 'arl', name: 'Account Monitor' },
    { value: 'fpml', name: 'FP Monitor' },
    { value: 'amlal', name: 'AML Monitor' },
  ];
  selectedApp;
  selectedUnit;

  constructor() {
    const formGroup = {};
    formGroup['app'] = new FormControl('', Validators.required);
    formGroup['note'] = new FormControl('', Validators.required);
    formGroup['bugTrackerId'] = new FormControl('', Validators.required);
    this.uploadForm = new UntypedFormGroup(formGroup);
  }

  ngOnInit(): void {
    this.getUnits();
  }

  getUnits() {
    this.filteredUnits = this.unitsControl.valueChanges.pipe(
      startWith('%'),
      distinctUntilChanged(),
      switchMap(value => {
        if (value.length > 2) {
          return this._filterUnits(value);
        }
        return [];
      })
    );
  }

  onFileSelected(event) {
    this.file = event.target.files[0];

    if (this.file) {
      this.fileName = this.file.name;
    }
  }

  onFileSubmit() {
    if (
      this.uploadForm.valid &&
      this.unitsControl.value.length > 0 &&
      this.file
    ) {
      const note = `Bug Tracker #${
        this.uploadForm.get('bugTrackerId').value
      }: ${this.uploadForm.get('note').value}`;
      const app = this.uploadForm.get('app').value;
      const formData = new FormData();
      formData.append('unitProfileXml', this.file);

      let obs: Observable<string> = null;
      obs = this.admnSrvc.postUnitProfile(
        formData,
        this.unitsControl.value,
        app,
        encodeURIComponent(note)
      );

      obs.subscribe(response => {
        if (response.indexOf('Success') >= 0) {
          this.status = `Uploaded ${this.fileName}`;
          this.statusClass = 'success';
        } else {
          this.status = `Error uploading ${this.fileName}`;
          this.statusClass = 'failure';
        }
      });
    } else {
      this.status = 'Missing required input';
      this.statusClass = 'failure';
    }
  }

  close() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  private _filterUnits(value: string) {
    if (!value) {
      value = '%25';
    }
    const list = this.admnSrvc
      .getUnitList(value, true)
      .pipe(map(data => data.names));
    return list;
  }
}
